import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";
import { LoyaltyRewardOffer } from "../../domain/models/loyalty-reward.model";

export interface LoyaltyRewardDialogData {
  offer: LoyaltyRewardOffer;
}

export type LoyaltyRewardDialogResult = "accept" | "dismiss";

@Component({
  selector: "ifp-loyalty-reward-dialog",
  templateUrl: "./loyalty-reward-dialog.component.html",
  styleUrls: ["./loyalty-reward-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoyaltyRewardDialogComponent {
  readonly actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.GoToDashboard, label: "GO TO DASHBOARD", buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Confirm, label: "ACTIVATE REWARD", buttonColor: ButtonColor.Primary },
  ];

  constructor(
    private readonly dialogRef: MatDialogRef<LoyaltyRewardDialogComponent, LoyaltyRewardDialogResult>,
    @Inject(MAT_DIALOG_DATA) public readonly data: LoyaltyRewardDialogData,
  ) {}

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Confirm) {
      this.dialogRef.close("accept");
      return;
    }

    this.dialogRef.close("dismiss");
  }
}
